import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { switchMap, shareReplay, map, filter } from 'rxjs/operators';

import { UpdatesModel } from 'models';
import { version } from 'config';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppVersionService {
    private isOutdated: Observable<boolean>;

    constructor(private updatesModel: UpdatesModel) {
        this.isOutdated = timer(0, 600000).pipe(
            filter(() => environment?.production && !environment?.beta),
            switchMap(() => this.updatesModel.getLatestVersion()),
            map((latestVersion: string) => this.isCurrentVersionOutdated(latestVersion)),
            shareReplay()
        );
    }

    isAppOutdated(): Observable<boolean> {
        return this.isOutdated;
    }

    private isCurrentVersionOutdated(stringLatestVersion: string): boolean {
        const currentVersion = this.createVersionFromString(version);
        const latestVersion = this.createVersionFromString(stringLatestVersion);

        return (
            currentVersion.major < latestVersion.major ||
            (currentVersion.major === latestVersion.major && currentVersion.minor < latestVersion.minor)
        );
    }

    private createVersionFromString(stringVersion: string): Version {
        const splitVersion = _.split(stringVersion, '.');
        return {
            major: _.parseInt(splitVersion[0]),
            minor: _.parseInt(splitVersion[1]),
            patch: _.parseInt(splitVersion[2])
        };
    }
}

interface Version {
    major: number;
    minor: number;
    patch: number;
}
